export default __webpack_public_path__ + "static/epilogue-3537343e1e3e9a0700e93d979b6675c5.svg";